import React from "react";
import {Typography} from "@material-ui/core";
import {app_singleton} from "../../utility/app_singleton";
import Popup, {ButtonTextJsx} from "../popup/popup";

interface Props {

}

type State = { is_open: false } | StateOpen

interface StateOpen {
    is_open: true,
    popup_data: app_singleton.close_popup_data
}

export default class Close_popup extends React.Component<Props, State> implements app_singleton.Observer_close_popup {
    constructor(props: Props) {
        super(props);
        this.state = {
            is_open: false,
        }
    }

    componentDidMount() {
        app_singleton.event.close_popup.attach(this);
    }

    componentWillUnmount() {
        app_singleton.event.close_popup.detach(this);
    }

    update_close_popup(obj: app_singleton.close_popup_data) {
        this.setState({
            popup_data: obj,
            is_open: true,
        });
    }

    handle_close_popup = () => {
        this.setState({is_open: false})
    }

    render() {

        const state = this.state;

        if (!state.is_open)
            return null;

        const {popup_data, is_open} = state

        const buttons = new ButtonTextJsx(undefined, {
                text: "Chiudi",
                on_click: async (stop_loading: () => void) => {
                    this.handle_close_popup();
                },
                enable_loading: true
            });

        return (
            <Popup title={popup_data.title}
                   open={is_open}
                   button={buttons}
                   handle_close={this.handle_close_popup}
            >
                <Typography>{popup_data.text}</Typography>
                {popup_data.content}
            </Popup>
        )
    }
}